import deskbookImage from 'assets/images/book-bonuses-image.webp'
import calendarIcon from 'assets/images/sprite/calendar-white-icon.svg'
import familyIcon from 'assets/images/sprite/family-white-icon.svg'
import moneyBagIcon from 'assets/images/sprite/money-bag-white-icon.svg'
import shieldTickIcon from 'assets/images/sprite/shield-tick-white-icon.svg'
import targetIcon from 'assets/images/sprite/target-white-icon.svg'

import { PageVersions } from 'root-constants'
import { TPageVersion, TPartialMap } from 'root-types'

export const CAROUSEL_SPACE_BETWEEN = 12

type TLandingWellnessBenefit = {
  titleKey: string
  descriptionKey?: string
}

type TLandingWellnessContent = {
  bannerKey: string
  titleKey: string
  subtitleKey: string
  ingredientsTitleKey: string
  benefits: readonly TLandingWellnessBenefit[]
  heroImage: string
}

const I18N_KEY_BASE = 'onboarding.landingWellness'

const CONTROL_BENEFITS: readonly TLandingWellnessBenefit[] = [
  {
    titleKey: `${I18N_KEY_BASE}.benefits.answers.title`,
    descriptionKey: `${I18N_KEY_BASE}.benefits.answers.description`,
  },
  {
    titleKey: `${I18N_KEY_BASE}.benefits.preparation.title`,
    descriptionKey: `${I18N_KEY_BASE}.benefits.preparation.description`,
  },
  {
    titleKey: `${I18N_KEY_BASE}.benefits.protocols.title`,
    descriptionKey: `${I18N_KEY_BASE}.benefits.protocols.description`,
  },
]

const TEST_BENEFITS: readonly TLandingWellnessBenefit[] = [
  {
    titleKey: `${I18N_KEY_BASE}.benefits.answers.title_v2`,
    descriptionKey: `${I18N_KEY_BASE}.benefits.answers.description_v2`,
  },
  {
    titleKey: `${I18N_KEY_BASE}.benefits.preparation.title_v2`,
    descriptionKey: `${I18N_KEY_BASE}.benefits.preparation.description`,
  },
  {
    titleKey: `${I18N_KEY_BASE}.benefits.protocols.title_v2`,
    descriptionKey: `${I18N_KEY_BASE}.benefits.protocols.description`,
  },
  {
    titleKey: `${I18N_KEY_BASE}.benefits.bonuses.title_v2`,
  },
]

export const LANDING_WELLNESS_CONTENT_BY_VERSION = {
  [PageVersions.V1]: {
    bannerKey: `${I18N_KEY_BASE}.discountBanner`,
    titleKey: `${I18N_KEY_BASE}.title`,
    subtitleKey: `${I18N_KEY_BASE}.subtitle`,
    ingredientsTitleKey: `${I18N_KEY_BASE}.ingredients.title`,
    benefits: CONTROL_BENEFITS,
    heroImage: deskbookImage,
  },
  [PageVersions.V2]: {
    bannerKey: `${I18N_KEY_BASE}.discountBanner_v2`,
    titleKey: `${I18N_KEY_BASE}.title_v2`,
    subtitleKey: `${I18N_KEY_BASE}.subtitle_v2`,
    ingredientsTitleKey: `${I18N_KEY_BASE}.ingredients.title_v2`,
    benefits: TEST_BENEFITS,
    heroImage: deskbookImage,
  },
} as const satisfies TPartialMap<TPageVersion, TLandingWellnessContent>

export const LANDING_WELLNESS_OUTCOMES = [
  {
    icon: moneyBagIcon,
    titleKey: 'onboarding.landingWellness.whatYouGet.savings.title',
    descriptionKey: 'onboarding.landingWellness.whatYouGet.savings.description',
  },
  {
    icon: targetIcon,
    titleKey: 'onboarding.landingWellness.whatYouGet.structure.title',
    descriptionKey:
      'onboarding.landingWellness.whatYouGet.structure.description',
  },
  {
    icon: shieldTickIcon,
    titleKey: 'onboarding.landingWellness.whatYouGet.safety.title',
    descriptionKey: 'onboarding.landingWellness.whatYouGet.safety.description',
  },
  {
    icon: familyIcon,
    titleKey: 'onboarding.landingWellness.whatYouGet.family.title',
    descriptionKey: 'onboarding.landingWellness.whatYouGet.family.description',
  },
  {
    icon: calendarIcon,
    titleKey: 'onboarding.landingWellness.whatYouGet.everyday.title',
    descriptionKey:
      'onboarding.landingWellness.whatYouGet.everyday.description',
  },
] as const

export const LANDING_WELLNESS_GUARANTEE_BLOCKS = [
  {
    titleKey: 'onboarding.landingWellness.guarantee.title',
    descriptionKey: 'onboarding.landingWellness.guarantee.description',
  },
  {
    titleKey: 'onboarding.landingWellness.remediesOverview.title',
    descriptionKey: 'onboarding.landingWellness.remediesOverview.description',
  },
] as const

export const LANDING_WELLNESS_FEATURES = [
  {
    titleKey: 'onboarding.landingWellness.features.devotion.title',
    descriptionKey: 'onboarding.landingWellness.features.devotion.description',
  },
  {
    titleKey: 'onboarding.landingWellness.features.sources.title',
    descriptionKey: 'onboarding.landingWellness.features.sources.description',
  },
  {
    titleKey: 'onboarding.landingWellness.features.explanations.title',
    descriptionKey:
      'onboarding.landingWellness.features.explanations.description',
  },
  {
    titleKey: 'onboarding.landingWellness.features.spreads.title',
    descriptionKey: 'onboarding.landingWellness.features.spreads.description',
  },
  {
    titleKey: 'onboarding.landingWellness.features.navigation.title',
    descriptionKey:
      'onboarding.landingWellness.features.navigation.description',
  },
] as const
